/* src/app/private/modules/manage-campaign/manage-campaign.component.scss */
.tab-container {
  display: flex;
  gap: 15px;
  overflow-x: auto;
}
.tab-container::-webkit-scrollbar {
  display: none;
}
.tab {
  padding: 7px 20px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid #FFFFFF;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2509803922) inset;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  font-weight: 600;
  border-bottom-width: 0px !important;
  height: 100%;
}
.outer-tab {
  border: 1px solid #FFFFFF;
  border-width: 1px 1px 1px 0px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  border-bottom-width: 0px !important;
}
.active {
  border-width: 1px 1px 1px 5px;
  border-style: solid;
  border-color: #F0950C;
  font-weight: bold;
  box-shadow: none !important;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
  font-size: 18px;
  padding: 8px 10px;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.action-button:hover {
  background-color: rgba(var(--primary-color), 0.1);
  transform: scale(1.2) rotate(90deg);
  color: var(--primary-color);
  box-shadow: 0 4px 12px rgba(var(--primary-color), 0.2);
}
.action-button:active {
  transform: scale(1.15) rotate(90deg);
}
.add-lead-space-outer {
  background-color: var(--primary-color);
  height: 30px;
  width: 30px;
  margin-top: 4px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.add-lead-space-inner {
  background-color: #fff;
  height: 19px;
  width: 19px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.spinner {
  height: 54vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.8rem;
  border-radius: 16px;
  font-weight: 500;
  font-size: 0.85rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.status-icon {
  margin-right: 0.4rem;
}
.sip-dialer-container {
  position: sticky;
  top: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  cursor: move;
  z-index: 10;
  height: 75vh;
  max-height: 75vh;
}
.sip-dialer-container:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.sip-dialer-container.minimized {
  width: 50px;
  cursor: default;
}
.sip-dialer-container.minimized .sip-dialer-header {
  justify-content: center;
  padding: 12px 8px;
}
.sip-dialer-header {
  background:
    linear-gradient(
      135deg,
      #294dec 0%,
      #041d77 100%);
  color: white;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  -webkit-user-select: none;
  user-select: none;
}
.sip-dialer-header:active {
  cursor: grabbing;
}
.sip-dialer-title {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
}
.sip-minimize-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.sip-minimize-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}
.sip-minimize-btn i {
  font-size: 12px;
}
.sip-dialer-content {
  height: calc(100% - 52px);
  overflow: hidden;
  transition: all 0.3s ease;
}
.sip-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.cdk-drag-preview {
  opacity: 0.8;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}
.cdk-drag-placeholder {
  opacity: 0.5;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
::ng-deep .p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}
::ng-deep .p-datatable .p-datatable-thead > tr > th {
  background-color: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 12px;
  font-weight: 600;
  font-size: 13px;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: fit-content;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th.s-no-column {
  width: 80px;
  text-align: center;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th.action-column {
  width: 100px;
  text-align: center;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th .header-content {
  display: flex;
  gap: 8px;
}
::ng-deep .p-datatable .p-datatable-tbody > tr {
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  background-color: #fafafa;
  box-shadow: inset 0 0 0 1px #e5e7eb;
}
::ng-deep .p-datatable .p-datatable-tbody > tr.even-row {
  background-color: #ffffff;
}
::ng-deep .p-datatable .p-datatable-tbody > tr.odd-row {
  background-color: #fafafa;
}
::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding: 14px 12px;
  font-size: 13px;
  color: #1f2937;
  min-width: fit-content;
}
::ng-deep .p-datatable .p-datatable-tbody > tr > td.s-no-column {
  width: 80px;
  text-align: center;
  font-weight: 600;
}
::ng-deep .p-datatable .p-datatable-tbody > tr > td.action-column {
  width: 100px;
  text-align: center;
}
::ng-deep .p-datatable .p-paginator {
  background-color: #f9fafb;
  border-top: 1px solid #e5e7eb;
  padding: 12px 16px;
}
::ng-deep .p-datatable .p-paginator .p-paginator-right {
  gap: 8px;
}
::ng-deep .sno-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}
::ng-deep .status-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
::ng-deep .status-chip.status-icon {
  font-size: 10px;
}
/*# sourceMappingURL=manage-campaign.component.css.map */
